module.exports = __webpack_public_path__ + "static/media/history-icon.c7e27192.svg";